import { NavLink, useNavigate, useParams } from "react-router-dom";
import "../css/MenuFrontal.css";

const MenuFrontal = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const normalizarTexto = (texto = "") =>
    texto
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase()
      .replace(/[\s_-]+/g, "");

  const leerStorage = (key, valorDefault = {}) => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : valorDefault;
    } catch {
      return valorDefault;
    }
  };

  const usuariosStorage = leerStorage("usuarios", {});
  const usuarioStorage = leerStorage("usuario", {});
  const userStorage = leerStorage("user", {});
  const permisosStorage = leerStorage("permisos", {});

  const instructorId =
    id ||
    usuariosStorage?._id ||
    usuarioStorage?._id ||
    userStorage?._id ||
    usuariosStorage?.instructor?._id ||
    usuarioStorage?.instructor?._id ||
    userStorage?.instructor?._id ||
    usuariosStorage?.instructorObjectId?._id ||
    usuarioStorage?.instructorObjectId?._id ||
    userStorage?.instructorObjectId?._id ||
    usuariosStorage?.id ||
    usuarioStorage?.id ||
    userStorage?.id ||
    "";

  const textoSesion = normalizarTexto(
    JSON.stringify({
      usuariosStorage,
      usuarioStorage,
      userStorage,
      permisosStorage,
    })
  );

  const esSuperAdmin =
    textoSesion.includes("superadmin") ||
    textoSesion.includes("super_admin");

  const modulosPermisos =
    permisosStorage?.modulos ||
    permisosStorage?.permisos ||
    usuariosStorage?.modulos ||
    usuariosStorage?.permisos ||
    usuarioStorage?.modulos ||
    usuarioStorage?.permisos ||
    userStorage?.modulos ||
    userStorage?.permisos ||
    [];

  const puedeVerModulo = (nombreModulo) => {
    if (esSuperAdmin) return true;

    const moduloBuscado = normalizarTexto(nombreModulo);

    const modulo = Array.isArray(modulosPermisos)
      ? modulosPermisos.find((item) => {
          const nombre =
            item?.nombreModulo ||
            item?.modulo ||
            item?.nombre ||
            item?.name ||
            item?.moduloObjectId?.nombreModulo ||
            item?.moduloObjectId?.nombre ||
            "";

          return normalizarTexto(nombre) === moduloBuscado;
        })
      : null;

    return (
      modulo?.puedeLeer === true ||
      modulo?.leer === true ||
      modulo?.read === true
    );
  };

  const puedeVerMiPerfil = () => {
    return puedeVerModulo("MiPerfil") || puedeVerModulo("Instructores");
  };

  const handleLogout = () => {
    localStorage.removeItem("usuarios");
    localStorage.removeItem("usuario");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("permisos");

    navigate("/", { replace: true });
  };

  const opcionesMenu = [
    {
      titulo: "Inicio",
      descripcion: "Panel principal del sistema",
      ruta: "/inicio",
      icono: "fas fa-home",
      color: "inicio",
      visible: true,
    },
    {
      titulo: "Mi Perfil",
      descripcion: "Información del usuario autenticado",
      ruta: "/perfil",
      icono: "fas fa-user",
      color: "perfil",
      visible: puedeVerMiPerfil(),
    },
    {
      titulo: "Contratos",
      descripcion: "Ver contratos asignados",
      ruta: `/instructor/listarcontratos/${instructorId}`,
      icono: "fa-solid fa-file-contract",
      color: "contratos",
      visible: Boolean(instructorId) && puedeVerMiPerfil(),
    },
    {
      titulo: "Firma",
      descripcion: "Actualizar firma digital",
      ruta: `/instructor/registrarfirma/${instructorId}`,
      icono: "fa-solid fa-signature",
      color: "firma",
      visible: Boolean(instructorId) && puedeVerMiPerfil(),
    },
    {
      titulo: "Instructor",
      descripcion: "Gestión de instructores",
      ruta: "/instructor/",
      icono: "fa-solid fa-chalkboard-user",
      color: "instructor",
      visible: puedeVerModulo("Instructores"),
    },
    {
      titulo: "Aprendices",
      descripcion: "Gestión de aprendices",
      ruta: "/aprendiz/",
      icono: "fa-solid fa-graduation-cap",
      color: "aprendices",
      visible: puedeVerModulo("Aprendices"),
    },
    {
      titulo: "Regional",
      descripcion: "Administración de regionales",
      ruta: "/institucional/regional/",
      icono: "fa-solid fa-map-location-dot",
      color: "regional",
      visible: puedeVerModulo("Regionales"),
    },
    {
      titulo: "Centro",
      descripcion: "Administración de centros",
      ruta: "/institucional/centro/",
      icono: "fa-solid fa-building-columns",
      color: "centro",
      visible: puedeVerModulo("Centros"),
    },
    {
      titulo: "Programas",
      descripcion: "Programas de formación",
      ruta: "/institucional/programas/",
      icono: "fa-solid fa-book-open",
      color: "programas",
      visible: puedeVerModulo("ProgramasFormacion"),
    },
    {
      titulo: "Grupos",
      descripcion: "Grupos de formación",
      ruta: "/institucional/grupos/",
      icono: "fa-solid fa-people-group",
      color: "grupos",
      visible: puedeVerModulo("Grupos"),
    },
    {
      titulo: "Mis Grupos",
      descripcion: "Grupos asignados al instructor",
      ruta: "/grupoinstructores",
      icono: "fas fa-user-plus",
      color: "grupos",
      visible: puedeVerModulo("Grupo Instructores"),
    },
    {
      titulo: "Entes",
      descripcion: "Entes conformadores",
      ruta: "/enteconformador/ente/",
      icono: "fa-solid fa-school",
      color: "entes",
      visible: puedeVerModulo("EntesConformadores"),
    },
    {
      titulo: "Jefes",
      descripcion: "Jefes inmediatos",
      ruta: "/enteconformador/jefes/",
      icono: "fa-solid fa-user-tie",
      color: "jefes",
      visible: puedeVerModulo("JefesInmediatos"),
    },
    {
      titulo: "Matrículas",
      descripcion: "Listado de matrículas",
      ruta: "/matricula/listarmatriculas/",
      icono: "fa-solid fa-list-check",
      color: "matriculas",
      visible: puedeVerModulo("Matriculas"),
    },
    {
      titulo: "Tarjeta UID",
      descripcion: "Tarjetas de aprendices",
      ruta: "/tarjeta/listartarjetaaprendiz/",
      icono: "fa-solid fa-id-card",
      color: "uid",
      visible: puedeVerModulo("TarjetaUID"),
    },
    {
      titulo: "Etapa Productiva",
      descripcion: "Seguimiento etapa productiva",
      ruta: "/etapaproductiva/listareproductiva/",
      icono: "fa-solid fa-briefcase",
      color: "productiva",
      visible: puedeVerModulo("EtapaProductiva"),
    },
    {
      titulo: "Reportes",
      descripcion: "Informes y reportes diarios",
      ruta: "/reportes",
      icono: "fas fa-chart-line",
      color: "reportes",
      visible: puedeVerModulo("Reportes"),
    },
    {
      titulo: "Notificaciones",
      descripcion: "Configuración de notificaciones",
      ruta: "/configuraciones/notificaciones",
      icono: "fas fa-bell",
      color: "notificaciones",
      visible: puedeVerModulo("Notificaciones"),
    },
    {
      titulo: "Roles y Permisos",
      descripcion: "Administrar acceso por rol",
      ruta: "/configuraciones/asignarmodulos",
      icono: "fas fa-user-shield",
      color: "permisos",
      visible: puedeVerModulo("RolesyPermisos"),
    },
    {
      titulo: "Ayuda",
      descripcion: "Soporte y ayuda del sistema",
      ruta: "/ayuda",
      icono: "fa-solid fa-handshake-angle",
      color: "ayuda",
      visible: true,
    },
    {
      titulo: "Cerrar sesión",
      descripcion: "Salir del sistema de forma segura",
      ruta: "#",
      icono: "fa-solid fa-right-from-bracket",
      color: "salir",
      visible: true,
      accion: handleLogout,
    },
  ].filter((item) => item.visible);

  return (
    <div className="menu-frontal-wrapper">
      <div className="menu-frontal-grid">
        {opcionesMenu.map((item) =>
          item.accion ? (
            <button
              key={item.titulo}
              type="button"
              onClick={item.accion}
              className="menu-frontal-card menu-frontal-button"
            >
              <div className={`menu-frontal-icon ${item.color}`}>
                <i className={item.icono}></i>
              </div>

              <div className="menu-frontal-content">
                <h5>{item.titulo}</h5>
                <p>{item.descripcion}</p>
              </div>

              <div className="menu-frontal-arrow">
                <i className="fa-solid fa-angle-right"></i>
              </div>
            </button>
          ) : (
            <NavLink
              key={item.ruta}
              to={item.ruta}
              className={({ isActive }) =>
                `menu-frontal-card ${isActive ? "active" : ""}`
              }
            >
              <div className={`menu-frontal-icon ${item.color}`}>
                <i className={item.icono}></i>
              </div>

              <div className="menu-frontal-content">
                <h5>{item.titulo}</h5>
                <p>{item.descripcion}</p>
              </div>

              <div className="menu-frontal-arrow">
                <i className="fa-solid fa-angle-right"></i>
              </div>
            </NavLink>
          )
        )}
      </div>

      {opcionesMenu.length === 0 && (
        <div className="menu-frontal-empty">
          <i className="fa-solid fa-lock"></i>
          <h5>Sin opciones disponibles</h5>
          <p>No tienes permisos asignados para visualizar módulos.</p>
        </div>
      )}

      <div className="menu-frontal-footer">
        {esSuperAdmin ? (
          <span>
            <i className="fa-solid fa-user-shield me-2"></i>
            Acceso total como SUPER_ADMIN
          </span>
        ) : (
          <span>
            <i className="fa-solid fa-lock me-2"></i>
            Opciones filtradas por permisos asignados
          </span>
        )}
      </div>
    </div>
  );
};

export default MenuFrontal;